import { useDisclosure } from '@chakra-ui/react'
import { useState } from 'react'

import {
	ICreateFolderParams,
	IHighlightsFolder,
	ISegment
} from '@/types/highlight.interface'
import { formatDate } from '@/utils/formatDate'
import { getFolderNameError } from '@/utils/validateFolderName'

interface IUseCreateFolderFromSegment {
	taskId?: string
	folders: IHighlightsFolder[]
	pendingSegment: ISegment | null
	createHighlightFolder: (params: ICreateFolderParams) => Promise<unknown>
	closeHighlightMenu: () => void
}

export const useCreateFolderFromSegment = ({
	taskId,
	folders,
	pendingSegment,
	createHighlightFolder,
	closeHighlightMenu
}: IUseCreateFolderFromSegment) => {
	const [newFolderName, setNewFolderName] = useState('')
	const [segmentForNewFolder, setSegmentForNewFolder] =
		useState<ISegment | null>(null)
	const [folderNameError, setFolderNameError] = useState('')

	const createFolderFromSegmentModal = useDisclosure()

	const openCreateFolderFromSegment = () => {
		if (!pendingSegment) return

		setSegmentForNewFolder(pendingSegment)
		setNewFolderName('')
		closeHighlightMenu()
		createFolderFromSegmentModal.onOpen()
	}

	const closeCreateFolderFromSegment = () => {
		createFolderFromSegmentModal.onClose()
		setNewFolderName('')
		setSegmentForNewFolder(null)
		setFolderNameError('')
		closeHighlightMenu()
	}

	const saveFolderFromSegment = async () => {
		if (!taskId || !segmentForNewFolder) return

		const error = getFolderNameError(newFolderName, folders)

		if (error) {
			setFolderNameError(error)
			return
		}

		const name =
			newFolderName.trim() || formatDate(new Date().toUTCString(), true)

		const payload = {
			segments: [segmentForNewFolder],
			taskId: taskId,
			name
		}

		closeCreateFolderFromSegment()

		try {
			await createHighlightFolder(payload)
		} catch (error) {
			console.log(error)
		}
	}

	return {
		newFolderName,
		setNewFolderName,
		folderNameError,
		setFolderNameError,
		createFolderFromSegmentModal,
		openCreateFolderFromSegment,
		closeCreateFolderFromSegment,
		saveFolderFromSegment
	}
}
